export const BOOKTICKET = "flightApp/bookticket";
export const DELETETICKET = "dynamicCounter/decrement";
